<!-- <tt-dashboard-widget-base [(ttDashboardWidget)]="ttDashboardWidget"> -->
<span class="tt-webpagemenu-dashboard-widget__value" [style.color]="ttDashboardWidget?.tile_heading_text_color">{{ ttDashboardWidget?.data1_text ?? "" }}</span>
<!-- </tt-dashboard-widget-base> -->
